<template>
    <div class="container-fluid w-100" style="overflow: hidden">
        <navbar :title="$t('menu.area_work')"/>
        <area-work-filter
            class="my-2"
            :user="user"
            :is-admin="false"
            @search="fetchAreaWork"
        />
        <!-- Add new one -->
        <div class="col-12">
            <div
                class="data-list-item add"
                @click.stop="addWork"
            >
                <div class="item-img-cont add-title">
                    <i class="fa fa-plus" />
                </div>
                <div class="item-text-cont">
                    <span class="item-title-add">{{ $t('common.add_new') }}</span>
                    <font-awesome-icon
                        icon="barcode"
                        class="card-body-icon"
                    />
                </div>
            </div>
        </div>

        <div
          v-if="results.length > 0"
          class="button-container col-sm-12 trip-buttons"
        >
          <button
            :disabled="results.length < 1"
            class="form-button btn btn-outline-success"
            style="background-color: #FFFFFF"
            @click="exportExcel"
          >
            {{ $t('trip.download_excel') }}
          </button>
        </div>
    <!-- Work record list -->
        <area-work-list :results="results" @edit="editWork"/>
    <!-- Editor -->
    <base-modal v-if="areaWorkItem" hide-footer hide-header @close="areaWorkItem = null">
      <area-work-editor
        :user="user"
        :area-id="areaWorkItem.id"
        @close="areaWorkItem = undefined"
        @close-and-update="workUpdated"
      />
    </base-modal>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import {areaHelper} from '../../mixins/AreaMixin'
import AreaWorkEditor from "./AreaWorkEditor";
import AreaWorkFilter from "./AreaWorkFilter";
import AreaWorkList from "./AreaWorkList";
import {downloadHelper} from "../../mixins/DownloadMixin";
import BaseModal from "@/components/BaseModal";
import Navbar from "@/components/utils/Navbar";
import {inject} from "vue";

export default {
    name: 'AreaWork',
    components: {
        Navbar,
        BaseModal,
        AreaWorkList,
        AreaWorkFilter,
        AreaWorkEditor
    },
    mixins: [restApi, areaHelper, downloadHelper],
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: true,
            error: false,
            areaWorkItem: null,
            results: [],
            lastSearchedParams: null
        }
    },
    mounted: function () {
        this.loading = false
    },
    methods: {
        fetchAreaWork: function (params) {
            this.loading = true
            this.results = []
            this.lastSearchedParams = params
            this.restFetchParams(this.areaWorkUrl, this.lastSearchedParams, this.handleResponse, this.handleError)
        },

        handleError: function (error) {
            this.loading = false
            if (error.response.status && error.response.status !== 200) {
                this.showAlert(this.$t('equipment.err_general'))
            }
        },

        handleResponse: function (response) {
            this.loading = false
            this.results = response.data
        },

        addWork: function () {
            this.areaWorkItem = {id: null}
        },

        exportExcel: function () {
            this.loading = true
            this.restGetDownloadFile(this.areaWorkReportXlsxUrl, this.getCommonReportParams(this.lastSearchedParams), this.excelDownloadSuccess, this.fileDownloadFail)
        },

        excelDownloadSuccess: function (response) {
            this.loading = false
            this.downloadFile(response, this.$t('areas.report_file_name'))
        },

        fileDownloadFail: function () {
            this.loading = false
            this.showAlert(this.$t('common.report_generation_failed'))
        },

        editWork: function (item) {
            this.areaWorkItem = item
        },

        closeAndUpdate: function () {
            this.fetchAreaWork(this.lastSearchedParams)
        },

        workUpdated: function () {
          this.areaWorkItem = undefined
          if ((this.results && this.results.length > 0) || this.lastSearchedParams.length > 0) {
              this.fetchAreaWork(this.lastSearchedParams)
          }
        }

    }
}
</script>

<style scoped>
.result-info {
    margin-left: 1em;
    margin-bottom: 10px;
}
</style>
